

import React from "react";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  Grid,
} from "@mui/material";

const Footer = () => {


  return (
    <Box
      sx={{
        // margin: {md:"40px"},
        // padding: {xs:3,md:7},
        // marginBottom: 4,
      }}

    >
      {/* Main Footer Section */}
      <Box
        sx={{


          // borderRadius: "20px",
          // backgroundColor: "#F9BF10",
          padding: "30px 24px 10px 24px",
          // borderTop: "1px solid #ddd",
        }}
      >

        <Box sx={{
          //  borderTop: "1px solid black",
          py: 1, mt: 1
        }}>
          <Typography variant="body1" color="gray" align="end">
            Design & Developed by Cygnusa Technologies
            {/* Copyright {" "}
            <span style={{ color: "gray" }}>{new Date().getFullYear()}</span> Pethowz |
            All Rights Reserved. */}
          </Typography>
        </Box>
      </Box>


    </Box>
  );
};

export default Footer;
